import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  Heart, Users, Globe, ArrowRight, MapPin, Building2, Crown, 
  Briefcase, GraduationCap, Handshake, Leaf, Scale, UserCheck, UsersRound, Mail
} from 'lucide-react';
import { Button } from '../components/ui/button';

const PAYPAL_LINK = "https://www.paypal.com/donate/?hosted_button_id=ZUX3BKRN524VS";

// OPAD Leadership Team - 7 Members
const leadershipTeam = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/ss40kda8_ChatGPT%20Image%20Mar%208%2C%202026%2C%2004_17_41%20AM.png",
    name: "Dr. Frank Kanu",
    role: "President & Founder",
    email: "frank@opad.eu",
    bio: "Founder and visionary leader of OPAD, driving global poverty alleviation and sustainable development initiatives."
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/roths7yl_Amb.%20Dr.%20Carlos%20Garcia.jpeg",
    name: "Amb. Dr. Carlos Garcia",
    role: "Chief Representative to UN",
    email: "carlos.garcia@opad.eu",
    bio: "Leading OPAD's engagement with UN agencies and international diplomatic initiatives."
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/q1y4t67x_Lester%20Sandres%20Rapalo.jpeg",
    name: "Dr. Lester Sandres Rapalo",
    role: "Ambassador & Global Advisor",
    email: "lester@opad.eu",
    bio: "Strategic advisor providing guidance on global development partnerships and humanitarian programmes."
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/h2m5ooyf_Dr.%20Caesar%20Campos.jpg",
    name: "Mrs. Gisela Alers Jaramillo",
    role: "Director of Partnerships",
    email: "partnerships@opad.eu",
    bio: "Building strategic alliances and institutional partnerships to expand OPAD's global impact."
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/5wx9zs4x_caeser.jpeg",
    name: "Dr. Caesar Campos",
    role: "US West Coast Project Director",
    email: "caesar.campos@opad.eu",
    bio: "Directing project implementation and community development initiatives across the US West Coast."
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/hijrll6a_Mrs.%20Gisela%20Alers%20Jaramillo.jpeg",
    name: "Ms. Di Wang",
    role: "Director SDGs Internship Program ASIA",
    email: "di.wang@opad.eu",
    bio: "Leading the SDGs internship programme across Asia, empowering young professionals in sustainable development."
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/k131m9ke_Mrs.%20Madelyn%20Rodriguez.jpeg",
    name: "Mrs. Madelyn Rodriguez",
    role: "Director of Public Relations",
    email: "pr@opad.eu",
    bio: "Managing OPAD's communications, media relations, and public engagement strategies worldwide."
  }
];

// Global Team Members with Photos (additional team)
const globalTeamMembers = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/ss40kda8_ChatGPT%20Image%20Mar%208%2C%202026%2C%2004_17_41%20AM.png",
    name: "Dr. Frank Kanu",
    role: "Founder & President"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/roths7yl_Amb.%20Dr.%20Carlos%20Garcia.jpeg",
    name: "Amb. Dr. Carlos Garcia",
    role: "Chief Representative to UN"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/q1y4t67x_Lester%20Sandres%20Rapalo.jpeg",
    name: "Dr. Lester Sandres Rapalo",
    role: "Ambassador & Global Advisor"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/h2m5ooyf_Dr.%20Caesar%20Campos.jpg",
    name: "Mrs. Gisela Alers Jaramillo",
    role: "Director of Partnerships"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/5wx9zs4x_caeser.jpeg",
    name: "Dr. Caesar Campos",
    role: "US West Coast Project Director"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/hijrll6a_Mrs.%20Gisela%20Alers%20Jaramillo.jpeg",
    name: "Ms. Di Wang",
    role: "Director SDGs Internship Program ASIA"
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_10eec864-0b4d-4948-b760-389570b9159b/artifacts/k131m9ke_Mrs.%20Madelyn%20Rodriguez.jpeg",
    name: "Mrs. Madelyn Rodriguez",
    role: "Director of Public Relations"
  }
];

// Executive Leadership Team
const executiveLeadership = [
  { name: "Dr. Frank Kanu", role: "President & Founder" },
  { name: "Amb. Dr. Carlos Garcia", role: "Chief Representative to UN" },
  { name: "Dr. Lester Sandres Rapalo", role: "Ambassador & Global Advisor" },
  { name: "Mrs. Gisela Alers Jaramillo", role: "Director of Partnerships" },
  { name: "Dr. Caesar Campos", role: "US West Coast Project Director" },
  { name: "Dr. Al Shek Kamara", role: "Director of Programs, OPAD USA Chapter" },
  { name: "Ms. Di Wang", role: "Director SDGs Internship Program ASIA" },
  { name: "Mrs. Madelyn Rodriguez", role: "Director of Public Relations" }
];

// Regional Offices
const regionalOffices = [
  {
    id: "europe",
    title: "OPAD Europe Regional Office",
    location: "Stockholm, Sweden",
    color: "#7BC4E2",
    bgColor: "bg-[#7BC4E2]/10",
    description: "Based in Sweden, OPAD's Europe Regional Team coordinates humanitarian and development programmes across EU Member States. This includes community food distribution initiatives in Botkyrka Municipality, youth capacity-building programmes through YIBO – Sweden, and transnational project partnerships implemented under Erasmus+ and other EU cooperation frameworks."
  },
  {
    id: "north-america",
    title: "North America Programme Support Team",
    location: "New York, United States",
    color: "#E08B7A",
    bgColor: "bg-[#E08B7A]/10",
    description: "The OPAD USA team supports global fundraising initiatives, diaspora engagement, partnership mobilisation, and advocacy for SDG-aligned programmes across North America—strengthening OPAD's international cooperation and institutional outreach."
  },
  {
    id: "west-africa",
    title: "OPAD West Africa Regional Office",
    location: "Freetown, Sierra Leone",
    color: "#E5B75F",
    bgColor: "bg-[#E5B75F]/10",
    description: "The West Africa team leads OPAD's poverty alleviation, youth empowerment, community health, and resilience-building programmes across Sierra Leone, Nigeria, and neighbouring countries—working closely with grassroots partners and local stakeholders."
  },
  {
    id: "east-africa",
    title: "OPAD East Africa Programme Team",
    location: "Addis Ababa, Ethiopia",
    color: "#4A7C59",
    bgColor: "bg-[#4A7C59]/10",
    description: "Focused on youth skill development and employment initiatives, this team implements capacity-building programmes through strategic partnerships with civil society organizations, academic institutions, and international development agencies across East Africa."
  },
  {
    id: "southern-africa",
    title: "OPAD Southern Africa Regional Network",
    location: "Lusaka, Zambia",
    color: "#9DB9A3",
    bgColor: "bg-[#9DB9A3]/10",
    description: "The Southern Africa network supports climate resilience, gender equality, and livelihood development programmes—promoting inclusive economic participation among underserved communities."
  },
  {
    id: "asia",
    title: "OPAD Asia Regional Team",
    location: "Islamabad, Pakistan",
    color: "#8B5CF6",
    bgColor: "bg-[#8B5CF6]/10",
    description: "OPAD's Asia Team advances knowledge exchange, youth innovation, digital inclusion, and disaster risk reduction programmes through collaboration with academic institutions and regional partners."
  },
  {
    id: "latin-america",
    title: "OPAD Latin America Programme Office",
    location: "San Salvador, El Salvador",
    color: "#F59E0B",
    bgColor: "bg-[#F59E0B]/10",
    description: "Engaged in youth empowerment, social inclusion, and sustainable development initiatives, the Latin America office collaborates with local civil society organizations to implement community-based interventions across the region."
  }
];

// Advisory Board Categories
const advisoryCategories = [
  { icon: Briefcase, title: "Development Experts", color: "#7BC4E2" },
  { icon: Globe, title: "EU Project Consultants", color: "#E08B7A" },
  { icon: GraduationCap, title: "Youth Empowerment Specialists", color: "#E5B75F" },
  { icon: Leaf, title: "Climate Action Advocates", color: "#4A7C59" },
  { icon: Scale, title: "Social Inclusion Advisors", color: "#9DB9A3" }
];

export default function TeamPage() {
  return (
    <div data-testid="team-page" className="pt-20">
      {/* Hero Section */}
      <section className="relative section-padding overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C5F41] via-[#4A7C59] to-[#6B9B7A]">
          <div className="absolute top-0 right-0 w-[500px] h-[450px] bg-white/10 rounded-bl-[250px]" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[350px] bg-[#E5B75F]/20 rounded-tr-[180px]" />
          <div className="absolute top-[30%] left-[10%] w-[150px] h-[150px] bg-[#7BC4E2]/15 rounded-full" />
        </div>
        
        <div className="container-custom relative z-10">
          <motion.div
            className="text-center max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
              <Globe className="w-5 h-5 text-[#E5B75F]" />
              <span className="text-white/90 text-sm font-medium">Global Team</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-['Manrope'] text-white mb-6 leading-tight">
              Meet the Global Team <span className="text-[#E5B75F]">Driving Change</span> Across Continents
            </h1>
            <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto">
              Our global leadership and regional programme teams work collaboratively across Europe, Africa, 
              Asia, North and South America to design, implement, and scale OPAD's humanitarian assistance, 
              climate action, youth empowerment, gender inclusion, and poverty alleviation programmes worldwide.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Operational Structure Description */}
      <section className="relative py-16 overflow-hidden">
        <div className="absolute inset-0 bg-white">
          <div className="absolute top-0 right-0 w-[400px] h-[350px] bg-[#7BC4E2]/10 rounded-bl-[180px]" />
          <div className="absolute bottom-0 left-0 w-[300px] h-[250px] bg-[#E08B7A]/10 rounded-tr-[120px]" />
        </div>
        
        <div className="container-custom relative z-10">
          <motion.div
            className="text-center max-w-4xl mx-auto bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-slate-100"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-lg text-slate-600 leading-relaxed">
              Through a <span className="text-[#4A7C59] font-semibold">decentralized yet coordinated operational structure</span>, 
              our teams ensure that locally driven solutions are delivered with global expertise—advancing inclusive 
              and sustainable development outcomes across the communities we serve.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Global Team Photo Grid Section */}
      <section className="relative section-padding overflow-hidden" data-testid="global-team-section">
        <div className="absolute inset-0 bg-gradient-to-br from-[#4A7C59]/5 via-white to-[#7BC4E2]/5">
          <div className="absolute top-0 left-0 w-[400px] h-[350px] bg-[#E5B75F]/10 rounded-br-[200px]" />
          <div className="absolute bottom-0 right-0 w-[350px] h-[300px] bg-[#E08B7A]/10 rounded-tl-[150px]" />
        </div>
        
        <div className="container-custom relative z-10">
          <motion.div 
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 bg-[#4A7C59]/20 rounded-full px-4 py-2 mb-4">
              <UsersRound className="w-5 h-5 text-[#4A7C59]" />
              <span className="text-[#4A7C59] text-sm font-semibold">OPAD Global Team</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold font-['Manrope'] text-slate-900 mb-4">
              Meet Our Global Team Members
            </h2>
            <p className="text-slate-600 max-w-3xl mx-auto">
              Our dedicated team members work across continents to deliver impactful programmes 
              in poverty alleviation, education, climate action, and sustainable development.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-6">
            {globalTeamMembers.map((member, index) => (
              <motion.div
                key={member.id}
                className="group relative"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                data-testid={`team-member-${member.id}`}
              >
                <div className="relative overflow-hidden rounded-2xl shadow-lg aspect-[3/4] bg-slate-100">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-white font-semibold text-sm truncate">{member.name}</h3>
                    <p className="text-white/80 text-xs truncate">{member.role}</p>
                  </div>
                </div>
                {/* Static name display below image */}
                <div className="mt-2 text-center">
                  <h3 className="font-semibold text-slate-900 text-sm truncate">{member.name}</h3>
                  <p className="text-slate-500 text-xs truncate">{member.role}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Executive Leadership Section */}
      <section className="relative section-padding overflow-hidden" data-testid="leadership-section">
        <div className="absolute inset-0 bg-[#FDF8F4]">
          <div className="absolute top-0 left-0 w-[450px] h-[400px] bg-[#E5B75F]/15 rounded-br-[200px]" />
          <div className="absolute bottom-0 right-0 w-[400px] h-[350px] bg-[#7BC4E2]/15 rounded-tl-[180px]" />
        </div>
        
        <div className="container-custom relative z-10">
          <motion.div 
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 bg-[#E5B75F]/20 rounded-full px-4 py-2 mb-4">
              <Crown className="w-5 h-5 text-[#E5B75F]" />
              <span className="text-[#E5B75F] text-sm font-semibold">OPAD Global Secretariat</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold font-['Manrope'] text-slate-900 mb-4">
              Executive Leadership
            </h2>
            <p className="text-slate-600 max-w-3xl mx-auto">
              The OPAD Global Secretariat provides strategic leadership, programme oversight, partnership coordination, 
              and institutional compliance across all regional and country offices. The Secretariat ensures alignment 
              with international development frameworks, including the United Nations Sustainable Development Goals (SDGs) 
              and EU-funded programme priorities.
            </p>
          </motion.div>

          <motion.div
            className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg border border-slate-100 overflow-hidden max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="overflow-x-auto">
              <table className="w-full" data-testid="leadership-table">
                <thead className="bg-gradient-to-r from-[#4A7C59] to-[#5A8C69]">
                  <tr>
                    <th className="px-6 py-4 text-left text-white font-semibold">Name</th>
                    <th className="px-6 py-4 text-left text-white font-semibold">Role</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {executiveLeadership.map((leader, index) => (
                    <motion.tr 
                      key={leader.name}
                      className="hover:bg-slate-50 transition-colors"
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      data-testid={`leader-${leader.name.replace(/\s+/g, '-').toLowerCase()}`}
                    >
                      <td className="px-6 py-4">
                        <span className="font-semibold text-slate-900">{leader.name}</span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-[#E08B7A] font-medium">{leader.role}</span>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Regional Offices Grid */}
      <section className="relative section-padding overflow-hidden">
        <div className="absolute inset-0 bg-white">
          <div className="absolute top-0 right-0 w-[500px] h-[450px] bg-[#7BC4E2]/10 rounded-bl-[250px]" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[350px] bg-[#E5B75F]/10 rounded-tr-[180px]" />
        </div>
        
        <div className="container-custom relative z-10">
          <motion.div 
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 bg-[#7BC4E2]/20 rounded-full px-4 py-2 mb-4">
              <Building2 className="w-5 h-5 text-[#7BC4E2]" />
              <span className="text-[#7BC4E2] text-sm font-semibold">Regional Presence</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold font-['Manrope'] text-slate-900 mb-4">
              Our Global Offices
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-6">
            {regionalOffices.map((office, index) => (
              <motion.div
                key={office.id}
                className="bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-lg border border-slate-100 hover:shadow-xl transition-all"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                data-testid={`office-${office.id}`}
              >
                <div className="flex items-start gap-4 mb-4">
                  <div 
                    className={`w-12 h-12 ${office.bgColor} rounded-xl flex items-center justify-center flex-shrink-0`}
                  >
                    <MapPin className="w-6 h-6" style={{ color: office.color }} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold font-['Manrope'] text-slate-900">
                      {office.title}
                    </h3>
                    <p className="text-sm font-medium" style={{ color: office.color }}>
                      Head Office: {office.location}
                    </p>
                  </div>
                </div>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {office.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisory Board Section */}
      <section className="relative section-padding overflow-hidden" data-testid="advisory-section">
        <div className="absolute inset-0 bg-[#FDF8F4]">
          <div className="absolute top-0 left-0 w-[400px] h-[350px] bg-[#4A7C59]/10 rounded-br-[180px]" />
          <div className="absolute bottom-0 right-0 w-[350px] h-[300px] bg-[#E08B7A]/10 rounded-tl-[150px]" />
        </div>
        
        <div className="container-custom relative z-10">
          <motion.div 
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 bg-[#4A7C59]/20 rounded-full px-4 py-2 mb-4">
              <UserCheck className="w-5 h-5 text-[#4A7C59]" />
              <span className="text-[#4A7C59] text-sm font-semibold">Expert Guidance</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold font-['Manrope'] text-slate-900 mb-4">
              Advisory Board
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              OPAD's Advisory Board brings together multidisciplinary experts who provide technical guidance, 
              programme oversight, and strategic insight across our thematic priority areas.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-4xl mx-auto">
            {advisoryCategories.map((category, index) => (
              <motion.div
                key={category.title}
                className="bg-white/90 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-slate-100 text-center"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div 
                  className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3"
                  style={{ backgroundColor: `${category.color}20` }}
                >
                  <category.icon className="w-6 h-6" style={{ color: category.color }} />
                </div>
                <p className="text-sm font-medium text-slate-700">{category.title}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Our Global Team CTA */}
      <section className="relative section-padding overflow-hidden" data-testid="join-team-section">
        <div className="absolute inset-0 bg-gradient-to-br from-[#E08B7A] via-[#E99A8A] to-[#F0A99A]">
          <div className="absolute top-0 right-0 w-[400px] h-[350px] bg-white/15 rounded-bl-[200px]" />
          <div className="absolute bottom-0 left-0 w-[300px] h-[250px] bg-[#E5B75F]/20 rounded-tr-[150px]" />
          <div className="absolute top-[50%] left-[50%] w-[200px] h-[200px] bg-white/10 rounded-full transform -translate-x-1/2 -translate-y-1/2" />
        </div>
        
        <div className="container-custom relative z-10">
          <motion.div
            className="text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Users className="w-16 h-16 text-white mx-auto mb-6" />
            <h2 className="text-3xl md:text-4xl font-bold font-['Manrope'] text-white mb-4">
              Join Our Global Team
            </h2>
            <p className="text-xl text-white/90 mb-4">
              Become Part of OPAD's Global Movement for Sustainable Development
            </p>
            <p className="text-white/80 mb-8">
              Whether you are a student, professional, researcher, or development partner, 
              OPAD offers opportunities to contribute to meaningful, community-driven change worldwide.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/internship" data-testid="team-internship-button">
                <Button className="bg-[#E5B75F] text-slate-900 hover:bg-[#D4A64E] rounded-full px-8 py-6 text-lg font-semibold w-full sm:w-auto">
                  <GraduationCap className="w-5 h-5 mr-2" />
                  Apply for Internship
                </Button>
              </Link>
              <Link to="/get-involved" data-testid="team-volunteer-button">
                <Button className="bg-[#7BC4E2] text-white hover:bg-[#6AB3D1] rounded-full px-8 py-6 text-lg font-semibold w-full sm:w-auto">
                  <Heart className="w-5 h-5 mr-2" />
                  Join as Volunteer
                </Button>
              </Link>
              <Link to="/partnership" data-testid="team-partnership-button">
                <Button className="bg-white text-[#E08B7A] hover:bg-slate-100 rounded-full px-8 py-6 text-lg font-semibold w-full sm:w-auto">
                  <Handshake className="w-5 h-5 mr-2" />
                  Partner With Us
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Values Section */}
      <section className="relative section-padding overflow-hidden" data-testid="team-values-section">
        <div className="absolute inset-0 bg-white">
          <div className="absolute top-0 right-0 w-[500px] h-[400px] bg-[#7BC4E2]/10 rounded-bl-[200px]" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[350px] bg-[#E5B75F]/10 rounded-tr-[150px]" />
        </div>
        
        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold font-['Manrope'] text-slate-900 mb-4">
              What Unites Us
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Our shared values guide everything we do and bring us together as a global family.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg text-center border border-slate-100"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <div className="w-16 h-16 bg-[#4A7C59]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="w-8 h-8 text-[#4A7C59]" />
              </div>
              <h3 className="text-xl font-bold font-['Manrope'] text-slate-900 mb-2">Compassion</h3>
              <p className="text-slate-600">We approach every person and community with empathy, respect, and genuine care.</p>
            </motion.div>

            <motion.div
              className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg text-center border border-slate-100"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <div className="w-16 h-16 bg-[#E08B7A]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-[#E08B7A]" />
              </div>
              <h3 className="text-xl font-bold font-['Manrope'] text-slate-900 mb-2">Unity</h3>
              <p className="text-slate-600">Together, we are stronger. We work as one global family to achieve our mission.</p>
            </motion.div>

            <motion.div
              className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg text-center border border-slate-100"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <div className="w-16 h-16 bg-[#E5B75F]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Globe className="w-8 h-8 text-[#E5B75F]" />
              </div>
              <h3 className="text-xl font-bold font-['Manrope'] text-slate-900 mb-2">Impact</h3>
              <p className="text-slate-600">Every action we take is focused on creating meaningful, lasting change in communities.</p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
